import './Theme.Page.CompactModal.scss';
import ThemePageModal from './Theme.Page.Modal';
export default `${ThemePageModal} ThemePageCompactModal`;
